
// eslint-disable-next-line import/prefer-default-export
export const paymentMethods = {
  card: {
    slug: 'credit_card',
    icon: true,
    title: null,
    description: null,
  },
  sms: {
    slug: 'sms',
    icon: false,
    title: 'СМС',
    description: 'только для России',
  },
  paypal: {
    slug: 'paypal',
    icon: true,
    title: null,
    description: null,
  },
};

export const SUBSCRIPTION_FOOTER_TEXTS = {
  pro: 'Новинки, бизнес-литературы, книги<br />по саморазвитию и аудиокниги',
  standard: 'В подписку не входят свежие поступления<br /> книг, бизнес-книги и аудиокниги',
};
